import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Divider,
  Grid,
  Button,
  IconButton,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { Edit, Save, Cancel, Print } from "@mui/icons-material";
import DynamicQuantityInput from "../PackAndBottleInputMUI";
import {
  clearSelectedArticle,
  setSelectedArticle,
} from "../../store/articleSlice";
import {
  setInputValue,
  setQuantity,
  selectQuantity,
} from "../../store/dynamicQteInmputSlice";
import { fetchSpecificSales,fetchRelatedOrders, createOrder, clearSelectedSale,clearAlerts, } from "../../store/salesSlice";
import { DocumentIdName } from "../../services/Enums";
import { formatQuantity, generateNumeroDoc, printSale } from "../../services/utils";
import MySelect from "../MySelect";
import { clearSelectedShop, fetchShops, setSelectedShop } from "../../store/shopSlice";
import { showSnackbar } from "../../store/snackbarSlice";



const SaleOrder = ({ closeOrder }) => {
  const dispatch = useDispatch();
  const { selectedSale,message,error, relatedOrders } = useSelector((state) => state.sale) || {};
  const { quantity } = useSelector(selectQuantity);
  const {shops,selectedShop,}=useSelector((state) => state.shop)
  
  

  const handleShopChange = (e) => {
    const shopId = e.target.value;
    const shop = shops.find((s) => s._id === shopId); // Find the full shop object
    dispatch(setSelectedShop(shop)); // Store full shop object
  };

  useEffect(() => {
    dispatch(fetchShops({page:1,limit:50}))
    dispatch(fetchRelatedOrders({page:1,limit:50,relatedOrder:selectedSale?._id}))

    return () => {
      dispatch(clearSelectedSale());
      dispatch(clearSelectedArticle());
      dispatch(clearSelectedShop());
      dispatch(clearAlerts());  
      
    };
  }, [dispatch]);


    useEffect(() => {
        if (message || error) {
          const type = message ? 'success' : 'error';
          const content = message || error;
      
          // Show snackbar with appropriate type
          setEditedArticles(
            selectedSale?.articles.map((article) => ({
              ...article,
              toDelivery: article.toDelivery || 0, // Initialize if not set
              calculatedDelivery: article.calculatedDelivery ?? 0,
            })) || []
          )
          dispatch(showSnackbar({ message: content, severity: type}));    
          dispatch(clearAlerts())
          // Clear the form and fetch articles if successful
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [message, error]);
  

      useEffect(() => {
        if (selectedSale) {
          setEditedArticles(
            selectedSale.articles.map((article) => ({
              ...article,
              toDelivery: article.toDelivery || 0,
              calculatedDelivery: article.calculatedDelivery ?? 0,
            }))
          );
        }
      }, [selectedSale]); // Update when selectedSale changes
      
  // Track which row is in edit mode
  const [editingRow, setEditingRow] = useState(null);

  // Track edited values in a separate state
  const [editedArticles, setEditedArticles] = useState(
    selectedSale?.articles.map((article) => ({
      ...article,
      toDelivery: article.toDelivery || 0, // Initialize if not set
      calculatedDelivery: article.calculatedDelivery ?? 0,
    })) || []
  );

  // Handle the edit mode for a specific row
  const handleEdit = (index) => {
    const articleToEdit = editedArticles[index];
    dispatch(setQuantity(articleToEdit.toDelivery)); // Update quantity in Redux
    dispatch(setInputValue(articleToEdit.toDelivery)); // Update quantity in Redux
    dispatch(setSelectedArticle(articleToEdit.article));
    setEditingRow(index);
  };

  // Save the modified value
  const handleSave = async (index) => {

    setEditedArticles((prev) =>
      prev.map((article, i) =>
        i === index ? { ...article, toDelivery: quantity } : article
      )
    );
    // Exit edit mode
    setEditingRow(null);
  };

  // Cancel the edit
  const handleCancel = () => setEditingRow(null);

  const createSaleCopyWithToDelivery = (printable) => {
    let allZero = true; // Flag to check if all toDelivery values are 0
    let hasError = false; // Flag to check if any quantity exceeds the remaining quantity

    const modifiedArticles = editedArticles.filter((article, index) => {
      const originalArticle = selectedSale.articles[index];
      const toDeliver = parseFloat(article.toDelivery || 0); // Default to 0 if not set

      const remainingQuantity =
        originalArticle.quantity - originalArticle.calculatedDelivery;

      // Validation: Ensure toDelivery does not exceed remaining quantity
      if (toDeliver > remainingQuantity) {
        alert(
          `Cannot exceed the remaining quantity for article: ${originalArticle.article.name}. Remaining quantity: ${remainingQuantity}`
        );
        hasError = true; // Set the error flag
        return false; // Exclude this article if validation fails
      }
      if (!selectedShop && selectedSale.mouvementType===DocumentIdName.COMMANDE_CLIENT) {
        alert(
          `Please select a shop to proceed.`
        );
        hasError = true; // Set the error flag
        return false; // Exclude this article if validation fails
      }

      // Mark allZero as false if any valid toDelivery is greater than 0
      if (toDeliver > 0) {
        allZero = false;
      }

      // Include the article only if the toDelivery value is modified and greater than 0
      return toDeliver > 0 && toDeliver !== (originalArticle.toDelivery || 0);
    });

    // If there is an error in any quantity, stop the process
    if (hasError) {
      return; // Stop further execution
    }

    // If no articles are valid or all toDelivery values are 0, notify the user
    if (allZero) {
      alert(
        "No quantity to deliver has been set. Please update the quantities before proceeding."
      );
      return;
    }

    // Create the sale copy only with modified articles
    const saleCopy = {
      ...selectedSale,
      relatedOrder: selectedSale._id,
      numero: generateNumeroDoc(),
      status: "PENDING",
      mouvementType:selectedSale.mouvementType===DocumentIdName.COMMANDE_CLIENT?DocumentIdName.ORDRE_DE_LIVRAISON : DocumentIdName.LIVRAISON,
      id: -1,
      shop: selectedSale.mouvementType===DocumentIdName.COMMANDE_CLIENT?selectedShop?._id:selectedSale.shop._id,
      articles: modifiedArticles.map((article) => ({
        ...article,
        quantity: article.toDelivery || 0,
      })),
    };

    // Dispatch the new sale copy
    dispatch(createOrder(saleCopy)).unwrap() // Ensure the action completes first
    .then(() => {
      dispatch(fetchSpecificSales({_id:selectedSale._id})).unwrap().then(()=>{
        if(printable){
          printSale(saleCopy,saleCopy.mouvementType===DocumentIdName.ORDRE_DE_LIVRAISON?"ORDRE DE LIVRAISON":"BON DE LIVRAISON")
        }
        dispatch(fetchRelatedOrders({page:1,limit:50,relatedOrder:selectedSale?._id}))
      })
    })
    .catch((error) => {
      console.error("Error creating order:", error);
    });

   
  };

  if (!selectedSale || Object.keys(selectedSale).length === 0) {
    return (
      <Box p={2}>
        <Typography variant="h6" align="center">
          No Sale selected. Please choose a sale to view the details.
        </Typography>
      </Box>
    );
  }

  return (
    <Box p={2}>
      <Typography variant="h4" gutterBottom>
        Details de la commande
      </Typography>

      {/* Sale info */}
      <Box mb={3}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body1">
              <strong>Numero:</strong> {selectedSale.numero}
            </Typography>
            <Typography variant="body1">
              <strong>Status:</strong> {selectedSale.status}
            </Typography>
            <Typography variant="body1">
              <strong>Shop:</strong> {selectedSale?.shop?.name}
            </Typography>
            <Typography variant="body1">
              <strong>Date:</strong>{" "}
              {new Date(selectedSale.date).toLocaleDateString()}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">
              <strong>Client/Fournisseur:</strong>{" "}
              {selectedSale.clientFournisseur.name || "N/A"}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ marginBottom: 2 }} />

      {/* Articles Table */}
      <Typography variant="h5" gutterBottom>
        Articles
      </Typography>
     
     {selectedSale.mouvementType===DocumentIdName.COMMANDE_CLIENT && 
      <Typography variant="h5" gutterBottom>
        <MySelect
          label="Select shop"
          options={shops}
          value={selectedShop?._id || ""}
          onChange={handleShopChange} 
          multiple={false}
          getOptionValue={(option) => option._id}
          getOptionLabel={(option) => option.name}
        />
      </Typography>}

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Article</TableCell>
              <TableCell align="right">Quantite</TableCell>
              <TableCell align="right">Quantite livrée</TableCell>
              {/* <TableCell align="right">Price</TableCell>
              <TableCell align="right">Total Price</TableCell> */}
               <TableCell align="right">Reste a livrer</TableCell>
              <TableCell>Livraison</TableCell>{" "}
              {/* Nouvelle colonne */}
            </TableRow>
          </TableHead>
          <TableBody>
      {editedArticles.map((article, index) => {
        // Calculate the remaining quantity
        const remainingQuantity = article.quantity - article.calculatedDelivery;

        return (
          <TableRow key={article._id || index}>
            <TableCell>{article.article.name}</TableCell>
            <TableCell align="right">
              {formatQuantity({
                isVenteDetail: article?.article?.isAlowSecondaryUnit,
                quantity: article?.quantity,
                nombreDePiece: article?.article?.unitsQte,
                primaryUnit: article?.article?.primaryUnits,
                secondaryUnit: article?.article?.secondaryUnits,
              })}
            </TableCell>
            <TableCell align="right">
              {formatQuantity({
                isVenteDetail: article?.article?.isAlowSecondaryUnit,
                quantity: article?.calculatedDelivery,
                nombreDePiece: article?.article?.unitsQte,
                primaryUnit: article?.article?.primaryUnits,
                secondaryUnit: article?.article?.secondaryUnits,
              })}
            </TableCell>
            <TableCell align="right">
              {formatQuantity({
                isVenteDetail: article?.article?.isAlowSecondaryUnit,
                quantity: remainingQuantity,
                nombreDePiece: article?.article?.unitsQte,
                primaryUnit: article?.article?.primaryUnits,
                secondaryUnit: article?.article?.secondaryUnits,
              })}
            </TableCell>
            <TableCell>
              {editingRow === index ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <DynamicQuantityInput />
                  <IconButton
                    onClick={() => handleSave(index)}
                    color="primary"
                  >
                    <Save />
                  </IconButton>
                  <IconButton onClick={handleCancel} color="secondary">
                    <Cancel />
                  </IconButton>
                </Box>
              ) : (
                <Box display="flex" alignItems="center" gap={1}>
                  {formatQuantity({
                    isVenteDetail: article?.article?.isAlowSecondaryUnit,
                    quantity: article?.toDelivery,
                    nombreDePiece: article?.article?.unitsQte,
                    primaryUnit: article?.article?.primaryUnits,
                    secondaryUnit: article?.article?.secondaryUnits,
                  })}

                  <IconButton
                    onClick={() => handleEdit(index)}
                    color="primary"
                  >
                    <Edit />
                  </IconButton>
                </Box>
              )}
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
        </Table>
      </TableContainer>

      <div >
        <Button
          variant="contained"
          color="primary"
          onClick={()=>{createSaleCopyWithToDelivery(false)}}
        >
          Creer un bon de livraison
        </Button>
        <br/>
        <br/>
        <Button
          variant="contained"
          color="primary"
          onClick={()=>{createSaleCopyWithToDelivery(true)}}
        >
          Creer et imprimer
        </Button>
      </div>

      <Box mt={3}>
       
        <Typography variant="h6">
          <strong>Repartition</strong> 
        </Typography>
       
      </Box>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
  <thead>
    <tr>
      <th style={{ border: "1px solid black", padding: "8px" }}>Numéro</th>
      <th style={{ border: "1px solid black", padding: "8px" }}>Status</th>
      <th style={{ border: "1px solid black", padding: "8px" }}>Shop</th>
      <th style={{ border: "1px solid black", padding: "8px" }}>Article</th>
      <th style={{ border: "1px solid black", padding: "8px" }}>Quantity</th>
      <th style={{ border: "1px solid black", padding: "8px" }}>Action</th>
    </tr>
  </thead>
  <tbody>
    {relatedOrders?.map((link, index) => {
      return (
        link.articles.map((article, idx) => (
          <tr key={`${index}-${idx}`}>
            {idx === 0 && (
              <>
                <td
                  rowSpan={link.articles.length}
                  style={{ border: "1px solid black", padding: "8px", verticalAlign: "top" }}
                >
                  {link.numero}
                </td>
                <td
                  rowSpan={link.articles.length}
                  style={{ border: "1px solid black", padding: "8px", verticalAlign: "top" }}
                >
                  {link.status}
                </td>
                <td
                  rowSpan={link.articles.length}
                  style={{ border: "1px solid black", padding: "8px", verticalAlign: "top" }}
                >
                  {link.shop.name}
                </td>
              </>
            )}
            <td style={{ border: "1px solid black", padding: "8px" }}>{article.article.name}</td>
            <td style={{ border: "1px solid black", padding: "8px", textAlign: "center" }}>{formatQuantity({
                    isVenteDetail: article?.article?.isAlowSecondaryUnit,
                    quantity: article?.quantity,
                    nombreDePiece: article?.article?.unitsQte,
                    primaryUnit: article?.article?.primaryUnits,
                    secondaryUnit: article?.article?.secondaryUnits,
                  })}</td>
            {idx === 0 && (
              <td
                rowSpan={link.articles.length}
                style={{ border: "1px solid black", padding: "8px", verticalAlign: "top", textAlign: "center" }}
              >
                <button onClick={()=>{printSale(link,link.mouvementType===DocumentIdName.ORDRE_DE_LIVRAISON?"ORDRE DE LIVRAISON":"BON DE LIVRAISON")}} style={{ padding: "5px 10px", cursor: "pointer" }}>
                  Print
                </button>
              </td>
            )}
          </tr>
        ))
      );
    })}
  </tbody>
</table>






    </Box>
  );
};

export default SaleOrder;
